let Components: any = {};

const ASSETS_URL = 'https://ff-icons.s3.eu-north-1.amazonaws.com/';

export const getIconByName = (svg: string): string => ASSETS_URL + svg;

import FireflinkMiniLogo from '../../assets/Icons/fireflink_mini_logo.svg?react';
import Add from '../../assets/Icons/add_plus.svg?react';
import RightArrowWhite from '../../assets/Icons/right-arrow-white.svg?react';
import SearchIcon from '../../assets/Icons/search_icon.svg?react';
import FireflinkLogo from '../../assets/Icons/fireflink_logo.svg?react';
import DeleteBlack from '../../assets/Icons/delete_black.svg?react';
import MoveBlack from '../../assets/Icons/move_black.svg?react';
import UnfoldMoreBlack from '../../assets/Icons/unfold_more_black.svg?react';
import TestData from '../../assets/Icons/test_data.svg?react';
import TestDataMenu from '../../assets/Icons/test_data_menu.svg?react';
import TestDataIcon from '../../assets/Icons/test_data_icon.svg?react';
import ConfigText from '../../assets/Icons/config_text.svg?react';
import Defect from '../../assets/Icons/defect.svg?react';
import Execution from '../../assets/Icons/execution.svg?react';
import ProjectMenu from '../../assets/Icons/project_menu.svg?react';
import Repository from '../../assets/Icons/repository.svg?react';
import TestDevelopment from '../../assets/Icons/test_development.svg?react';
import HttpDarkLogo from '../../assets/Icons/httpDark_logo.svg?react';
import NlpDarkLogo from '../../assets/Icons/nlpDark_logo.svg?react';
import ProjectDarkLogo from '../../assets/Icons/projectDark_logo.svg?react';
import RepositoryDarkLogo from '../../assets/Icons/repositoryDark_logo.svg?react';
import TestDataDarkLogo from '../../assets/Icons/testdataDark_logo.svg?react';
import AnalyticsDarkIcon from '../../assets/Icons/analyticsDark_icon.svg?react';
import ConfigurationDarkLogo from '../../assets/Icons/configurationDark_logo.svg?react';
import DashboardDarklogo from '../../assets/Icons/dashboardDark_logo.svg?react';
import DatabaseDarkLogo from '../../assets/Icons/databaseDark_logo.svg?react';
import Reorder from '../../assets/Icons/Reorder.svg?react';
import AutoRun from '../../assets/Icons/autoRun.svg?react';
import CancelIcon from '../../assets/Icons/cancel_icon.svg?react';
import EditIcon from '../../assets/Icons/edit_icon.svg?react';
import EmailIcon from '../../assets/Icons/email_icon.svg?react';
import MailIcon from '../../assets/Icons/mail_icon.svg?react';
import ReplaceIcon from '../../assets/Icons/replace_icon.svg?react';
import ShowPrePost from '../../assets/Icons/show_pre_post_condition.svg?react';
import ReplaceFileIcon from '../../assets/Icons/Replace_File_icon.svg?react';
import RunFailed from '../../assets/Icons/Run_failed.svg?react';
import SuitcaseIcon from '../../assets/Icons/suitcase_icon.svg?react';
import Terminate from '../../assets/Icons/terminate.svg?react';
import RepositoryIcon from '../../assets/Icons/Repository_icon.svg?react';
import Configuration from '../../assets/Icons/Configuration.svg?react';
import DashboardIcon from '../../assets/Icons/Dashboard_icon.svg?react';
import DefectDarkSVG from '../../assets/Icons/Defect_dark_svg.svg?react';
import RunSettings from '../../assets/Icons/run_settings.svg?react';
import ReplaceFile from '../../assets/Icons/replace_File.svg?react';
import AndroidSvg from '../../assets/Icons/android_svg.svg?react';
import MobileWebIcon from '../../assets/Icons/Mobile_web_icon.svg?react';
import AnalyticsBlueIcon from '../../assets/Icons/Analytics_Blue_icon.svg?react';
import ImpactListIcon from '../../assets/Icons/impact_list.svg?react';
import AnalyticsIcon from '../../assets/Icons/Analytics_icon.svg?react';
import webIcon from '../../assets/Icons/web_icon.svg?react';
import DashboardLogo from '../../assets/Icons/dashboard_logo.svg?react';
import ToggleMenu from '../../assets/Icons/toggle_menu.svg?react';
import CopyInitIcon from '../../assets/Icons/copy_init_icon.svg?react';
import ProjectMenuIcon from '../../assets/Icons/Project_Menu_icon.svg?react';
import AttachIcon from '../../assets/Icons/Attach_icon.svg?react';
import EyeLogo from '../../assets/Icons/eye_logo.svg?react';
import AnalyticIcon from '../../assets/Icons/analytic_icon.svg?react';
import DragIconBlack from '../../assets/Icons/drag_icon_black_24dp.svg?react';
import RepositoryLogo from '../../assets/Icons/repository_logo.svg?react';
import TestDataLogo from '../../assets/Icons/testdata_logo.svg?react';
import Info from '../../assets/Icons/info.svg?react';
import InfoIcon from '../../assets/Icons/info_icon.svg?react';
import CloseBlue from '../../assets/Icons/close_blue.svg?react';
import Close from '../../assets/Icons/close.svg?react';
import RemoveUserIcon from '../../assets/Icons/remove_user_icon.svg?react';
import ProjectLogo from '../../assets/Icons/project_logo.svg?react';
import DashboardBlueIcon from '../../assets/Icons/Dashboard_Blue_icon.svg?react';
import ArrowRight from '../../assets/Icons/arrow_right.svg?react';
import ArrowRightBlackFilled from '../../assets/Icons/arrow_right_black_filled.svg?react';
import ArrowDropDownBlack from '../../assets/Icons/arrow_drop_down_black.svg?react';
import HideAllFiles from '../../assets/Icons/hide_all_files.svg?react';
import ShowAllFiles from '../../assets/Icons/show_all_files.svg?react';
import ExpandAll from '../../assets/Icons/expand_all.svg?react';
import CollapseAll from '../../assets/Icons/Collapse-all.svg?react';
import Delete from '../../assets/Icons/delete.svg?react';
import Download from '../../assets/Icons/download.svg?react';
import PDF from '../../assets/Icons/pdf.svg?react';
import Word from '../../assets/Icons/word.svg?react';
import License from '../../assets/Icons/license.svg?react';
import Notification from '../../assets/Icons/notification.svg?react';
import UserProfile from '../../assets/Icons/user_profile.svg?react';
import CollapsedFireflink from '../../assets/Icons/collapsed_fireflink.svg?react';
import Fireflink from '../../assets/Icons/fireflink.svg?react';
import AnalyticsMenu from '../../assets/Icons/analytics_menu.svg?react';
import ConfigMenu from '../../assets/Icons/config_menu.svg?react';
import DashboardMenu from '../../assets/Icons/dashboard_menu.svg?react';
import DefectMenu from '../../assets/Icons/defect_menu.svg?react';
import ExecutionMenu from '../../assets/Icons/execution_menu.svg?react';
import LicenseMenu from '../../assets/Icons/license_menu.svg?react';
import ProjectSvg from '../../assets/Icons/project_svg.svg?react';
import ProjectsMenu from '../../assets/Icons/projects_menu.svg?react';
import RepositoryMenu from '../../assets/Icons/repository_menu.svg?react';
import Android from '../../assets/Icons/android.svg?react';
import Calendar from '../../assets/Icons/calendar.svg?react';
import CaraouselLeft from '../../assets/Icons/carousel_left.svg?react';
import CaraouselRight from '../../assets/Icons/carousel_right.svg?react';
import ClosedDefects from '../../assets/Icons/closed_defects.svg?react';
import Density from '../../assets/Icons/density.svg?react';
import RsFilterOutline from '../../assets/Icons/rs_filter_outline.svg?react';
import ArrowRightGray from '../../assets/Icons/arrow_right_gray.svg?react';
import ArrowDown from '../../assets/Icons/arrow_down.svg?react';
import ArrowUp from '../../assets/Icons/arrow_up.svg?react';
import ExpandArrow from '../../assets/Icons/expand_arrow.svg?react';
import Failed from '../../assets/Icons/failed.svg?react';
import FilterFilled from '../../assets/Icons/filter_filled.svg?react';
import Filter from '../../assets/Icons/filter.svg?react';
import FilterOutline from '../../assets/Icons/filter_outline.svg?react';
import Flaky from '../../assets/Icons/flaky.svg?react';
import Passed from '../../assets/Icons/passed.svg?react';
import QualityScore from '../../assets/Icons/quality_score.svg?react';
import RsFilterFilled from '../../assets/Icons/rs_filter_filled.svg?react';
import Shrink from '../../assets/Icons/shrink.svg?react';
import ShrinkDark from '../../assets/Icons/shrink_dark.svg?react';
import ShrinkWhite from '../../assets/Icons/shrink_white.svg?react';
import Skipped from '../../assets/Icons/skipped.svg?react';
import TotalDefects from '../../assets/Icons/total_detects.svg?react';
import Warning from '../../assets/Icons/warning.svg?react';
import Success from '../../assets/Icons/success.svg?react';
import CautionIcon from '../../assets/Icons/caution_icon.svg?react';
// import WarningIcon from '../../assets/Icons/warning_icon.svg?react';
import DangerIcon from '../../assets/Icons/danger_icon.svg?react';
import VersionControl from '../../assets/Icons/version_control.svg?react';
import ToastCloseIconDefault from '../../assets/Icons/toast_close_icon_defult.svg?react';
import ToastCloseIconHover from '../../assets/Icons/toast_close_icon_hover.svg?react';
import ToastInfo from '../../assets/Icons/toast_info.svg?react';
import ToastInformationClose from '../../assets/Icons/toast_information_close.svg?react';
import ToastSucess from '../../assets/Icons/toast_sucess.svg?react';
import Revert from '../../assets/Icons/revert.svg?react';
import ApprovalCount from '../../assets/Icons/approval_count.svg?react';
import ProjectEnvironmentVariables from '../../assets/Icons/project_environment_variables.svg?react';
import GlobalVariables from '../../assets/Icons/global_variables.svg?react';
import InfoGrey from '../../assets/Icons/info_grey.svg?react';
import ManualHighlight from '../../assets/Icons/manual_highlight.svg?react';
import CopyHightlight from '../../assets/Icons/copy_highlight.svg?react';
import AutoHighlight from '../../assets/Icons/auto_highlight.svg?react';
import Manual from '../../assets/Icons/manual.svg?react';
import Copy from '../../assets/Icons/copy.svg?react';
import Auto from '../../assets/Icons/auto.svg?react';
import BackArrowBtn from '../../assets/Icons/back_arrow_btn.svg?react';
import MoreIcon from '../../assets/Icons/more_icon.svg?react';
import SyncIcon from '../../assets/Icons/sync_icon.svg?react';
import ChatIcon from '../../assets/Icons/chat_icon.svg?react';
import LogoIcon from '../../assets/Icons/logo_icon.svg?react';
import RightArrowBlue from '../../assets/Icons/right_arrow_blue.svg?react';
import SendIcon from '../../assets/Icons/send_icon.svg?react';
import Inprogress from '../../assets/Icons/inprogress.svg?react';
import Mobile_Device from '../../assets/Icons/mobile_device.svg?react';
import AnalyticsDashboardIcon from '../../assets/Icons/analytics_dashboard_icon.svg?react';
import AutomationIcon from '../../assets/Icons/automation_icon.svg?react';
import Check from '../../assets/Icons/check.svg?react';
import Hide from '../../assets/Icons/hide.svg?react';
import ManageApps from '../../assets/Icons/manage_apps.svg?react';
import MenuIcon from '../../assets/Icons/menu_icon.svg?react';
import SearchTestDev from '../../assets/Icons/search_test_dev.svg?react';
import LicenseIcon from '../../assets/Icons/license_icon.svg?react';
import AddFilledIcon from '../../assets/Icons/add_filled_icon.svg?react';
import EditPencilIcon from '../../assets/Icons/edit_pencil_icon.svg?react';
import ArrowIcon from '../../assets/Icons/arrow.svg?react';
import ZipFileIcon from '../../assets/Icons/zip-file.svg?react';
import InfoIconWithBackground from '../../assets/Icons/info_danger.svg?react';
import RecordedElement from '../../assets/Icons/recorded_element.svg?react';
import AddEntity from '../../assets/Icons/add_entity.svg?react';
import ExpandIcon from '../../assets/Icons/expand_icon.svg?react';
import AddIcon from '../../assets/Icons/add_icon.svg?react';
import ExportIcon from '../../assets/Icons/export_icon.svg?react';
import VideoCamIcon from '../../assets/Icons/video_camera.svg?react';
import RemoveUser from '../../assets/Icons/remove_user.svg?react';
import Schedule from '../../assets/Icons/schedule.svg?react';
import CloseCircleIcon from '../../assets/Icons/close_circle_icon.svg?react';
import ClearResult from '../../assets/Icons/clear_result.svg?react';
import Maximize from '../../assets/Icons/maximum.svg?react';
import Minimize from '../../assets/Icons/minimum.svg?react';
import ManualTagged from '../../assets/Icons/manual_tagged.svg?react';
import ManualUnTagged from '../../assets/Icons/manual_untagged.svg?react';
import AiTagged from '../../assets/Icons/ai_tagged.svg?react';
import AiUnTagged from '../../assets/Icons/ai_untagged.svg?react';
import ViewMore from '../../assets/Icons/view_more.svg?react';
import Attachment from '../../assets/Icons/attachment.svg?react';
import SuiteIcon from '../../assets/Icons/suite_icon.svg?react';
import DownloadFilled from '../../assets/Icons/download_filled.svg?react';
import EditFilled from '../../assets/Icons/edit_filled.svg?react';
import AddCircled from '../../assets/Icons/add_circled.svg?react';
import Padlock from '../../assets/Icons/padlock.svg?react';
import BoldIcon from '../../assets/Icons/bold.svg?react';
import FontColorIcon from '../../assets/Icons/font_color.svg?react';
import ItalicIcon from '../../assets/Icons/italic.svg?react';
import UnderlineIcon from '../../assets/Icons/text_underline_icon.svg?react';
import FormatPainterIcon from '../../assets/Icons/format_painter.svg?react';
import RedoIcon from '../../assets/Icons/redo.svg?react';
import UndoIcon from '../../assets/Icons/undo.svg?react';
import PaintIcon from '../../assets/Icons/paint.svg?react';
import Help from '../../assets/Icons/help.svg?react';
import BorderAllSides from '../../assets/Icons/border_all.svg?react';
import BorderBottom from '../../assets/Icons/border_bottom_icon.svg?react';
import BorderLeft from '../../assets/Icons/border_left_icon.svg?react';
import BorderNone from '../../assets/Icons/border_none_icon.svg?react';
import BorderOuter from '../../assets/Icons/border_outer_icon.svg?react';
import BorderRight from '../../assets/Icons/border_right_icon.svg?react';
import BorderTop from '../../assets/Icons/border_top_icon.svg?react';
import TextAlignRight from '../../assets/Icons/text_align_right.svg?react';
import TextAlignCenter from '../../assets/Icons/text_align_center_icon.svg?react';
import TextAlignLeft from '../../assets/Icons/text_align_left_icon.svg?react';
import ActionExpand from '../../assets/Icons/actions_Expand.svg?react';
import ChatbotHeader from '../../assets/Icons/chatbot_header.svg?react';
import ChatbotLoader from '../../assets/Icons/chatbot_loader.svg?react';
import ChatbotLogo from '../../assets/Icons/chatbot_logo.svg?react';
import NewChat from '../../assets/Icons/new_chat.svg?react';
import ChatbotHiddenLogo from '../../assets/Icons/chatbot_hidden.svg?react';
import NlpSuggestionIcon from '../../assets/Icons/nlp_suggestion_icon.svg?react';
import Expand from '../../assets/Icons/expand.svg?react';
import Collapse from '../../assets/Icons/collapse.svg?react';
import OpenFullScreen from '../../assets/Icons/open_fullscreen.svg?react';
import CloseFullScreen from '../../assets/Icons/close_fullscreen.svg?react';
import CloseIcon from '../../assets/Icons/close_icon.svg?react';
import Dismiss from '../../assets/Icons/dismiss_icon.svg?react';
import LiveWebIcon from '../../assets/Icons/live_web_icon.svg?react';
import LiveMobileIcon from '../../assets/Icons/live_mobile_icon.svg?react';
import AutoFillSteps from '../../assets/Icons/auto_fill_steps_icon.svg?react';
import ViewDataSetIcon from '../../assets/Icons/viewdataseticon.svg?react';

//icons
Components['view_dataset_icon'] = ViewDataSetIcon;
Components['fireflink_mini_logo'] = FireflinkMiniLogo;
Components['plus'] = Add;
Components['right-arrow-white'] = RightArrowWhite;
Components['search_icon'] = SearchIcon;
Components['fireflink_logo'] = FireflinkLogo;
Components['delete_black'] = DeleteBlack;
Components['move_black'] = MoveBlack;
Components['unfold_more_black'] = UnfoldMoreBlack;
Components['test_data'] = TestData;
Components['test_data_menu'] = TestDataMenu;
Components['test_data_icon'] = TestDataIcon;
Components['config_text'] = ConfigText;
Components['defect'] = Defect;
Components['execution'] = Execution;
Components['project_menu'] = ProjectMenu;
Components['repository'] = Repository;
Components['test_development'] = TestDevelopment;
Components['httpDark_logo'] = HttpDarkLogo;
Components['nlpDark_logo'] = NlpDarkLogo;
Components['projectDark_logo'] = ProjectDarkLogo;
Components['repositoryDark_logo'] = RepositoryDarkLogo;
Components['testdataDark_logo'] = TestDataDarkLogo;
Components['analyticsDark_icon'] = AnalyticsDarkIcon;
Components['configurationDark_logo'] = ConfigurationDarkLogo;
Components['dashboardDark_logo'] = DashboardDarklogo;
Components['databaseDark_logo'] = DatabaseDarkLogo;
Components['Reorder'] = Reorder;
Components['autoRun'] = AutoRun;
Components['cancel_icon'] = CancelIcon;
Components['edit_icon'] = EditIcon;
Components['email_icon'] = EmailIcon;
Components['mail_icon'] = MailIcon;
Components['replace_icon'] = ReplaceIcon;
Components['show_pre_post'] = ShowPrePost;
Components['Replace_File_icon'] = ReplaceFileIcon;
Components['Run_failed'] = RunFailed;
Components['suitcase_icon'] = SuitcaseIcon;
Components['terminate'] = Terminate;
Components['Repository_icon'] = RepositoryIcon;
Components['Configuration'] = Configuration;
Components['Dashboard_icon'] = DashboardIcon;
Components['Defect_dark_svg'] = DefectDarkSVG;
Components['run_settings'] = RunSettings;
Components['replace_File'] = ReplaceFile;
Components['android_svg'] = AndroidSvg;
Components['Mobile_web_icon'] = MobileWebIcon;
Components['Analytics_Blue_icon'] = AnalyticsBlueIcon;
Components['impact_list_icon'] = ImpactListIcon;
Components['Analytics_icon'] = AnalyticsIcon;
Components['web_icon'] = webIcon;
Components['dashboard_logo'] = DashboardLogo;
Components['toggle_menu'] = ToggleMenu;
Components['copy_init_icon'] = CopyInitIcon;
Components['Project_Menu_icon'] = ProjectMenuIcon;
Components['Attach_icon'] = AttachIcon;
Components['eye_logo'] = EyeLogo;
Components['analytic_icon'] = AnalyticIcon;
Components['drag_icon_black_24dp'] = DragIconBlack;
Components['repository_logo'] = RepositoryLogo;
Components['testdata_logo'] = TestDataLogo;
Components['info'] = Info;
Components['info_icon'] = InfoIcon;
Components['close_blue'] = CloseBlue;
Components['close'] = Close;
Components['remove_user_icon'] = RemoveUserIcon;
Components['project_logo'] = ProjectLogo;
Components['Dashboard_Blue_icon'] = DashboardBlueIcon;
Components['arrow_right'] = ArrowRight;
Components['arrow_right_black_filled'] = ArrowRightBlackFilled;
Components['arrow_drop_down_black'] = ArrowDropDownBlack;
Components['hide_all_files'] = HideAllFiles;
Components['show_all_files'] = ShowAllFiles;
Components['expand_all'] = ExpandAll;
Components['Collapse_all'] = CollapseAll;
Components['delete'] = Delete;
Components['download'] = Download;
Components['pdf'] = PDF;
Components['word'] = Word;
Components['license'] = License;
Components['notification'] = Notification;
Components['user_profile'] = UserProfile;
Components['collapsed_fireflink'] = CollapsedFireflink;
Components['fireflink'] = Fireflink;
Components['analytics_menu'] = AnalyticsMenu;
Components['config_menu'] = ConfigMenu;
Components['dashboard_menu'] = DashboardMenu;
Components['defect_menu'] = DefectMenu;
Components['execution_menu'] = ExecutionMenu;
Components['license_menu'] = LicenseMenu;
Components['project_svg'] = ProjectSvg;
Components['projects_menu'] = ProjectsMenu;
Components['repository_menu'] = RepositoryMenu;
Components['android'] = Android;
Components['calendar'] = Calendar;
Components['carousel_left'] = CaraouselLeft;
Components['carousel_right'] = CaraouselRight;
Components['closed_defects'] = ClosedDefects;
Components['density'] = Density;
Components['arrow_right_gray'] = ArrowRightGray;
Components['arrow_down'] = ArrowDown;
Components['arrow_up'] = ArrowUp;
Components['expand_arrow'] = ExpandArrow;
Components['failed'] = Failed;
Components['filter'] = Filter;
Components['filter_filled'] = FilterFilled;
Components['filter_outline'] = FilterOutline;
Components['rs_filter_outline'] = RsFilterOutline;
Components['rs_filter_filled'] = RsFilterFilled;
Components['flaky'] = Flaky;
Components['passed'] = Passed;
Components['quality_score'] = QualityScore;
Components['shrink'] = Shrink;
Components['shrink_dark'] = ShrinkDark;
Components['shrink_white'] = ShrinkWhite;
Components['skipped'] = Skipped;
Components['total_detects'] = TotalDefects;
Components['warning'] = Warning;
Components['success'] = Success;
Components['caution_icon'] = CautionIcon;
Components['actions_expand'] = ActionExpand;
// Components['warning_icon'] = WarningIcon;
Components['danger_icon'] = DangerIcon;
Components['version_control'] = VersionControl;
Components['toast_close_icon_defult'] = ToastCloseIconDefault;
Components['toast_close_icon_hover'] = ToastCloseIconHover;
Components['toast_info'] = ToastInfo;
Components['toast_information_close'] = ToastInformationClose;
Components['toast_sucess'] = ToastSucess;
Components['revert'] = Revert;
Components['approval_count'] = ApprovalCount;
Components['project_environment_variables'] = ProjectEnvironmentVariables;
Components['global_variables'] = GlobalVariables;
Components['info_grey'] = InfoGrey;
Components['manual_highlight'] = ManualHighlight;
Components['copy_highlight'] = CopyHightlight;
Components['auto_highlight'] = AutoHighlight;
Components['manual'] = Manual;
Components['copy'] = Copy;
Components['auto'] = Auto;
Components['back_arrow_btn'] = BackArrowBtn;
Components['more_icon'] = MoreIcon;
Components['sync_icon'] = SyncIcon;
Components['chat_icon'] = ChatIcon;
Components['logo_icon'] = LogoIcon;
Components['right_arrow_blue'] = RightArrowBlue;
Components['send_icon'] = SendIcon;
Components['inprogress'] = Inprogress;
Components['mobile_device'] = Mobile_Device;
Components['analytics_dashboard_icon'] = AnalyticsDashboardIcon;
Components['automation_icon'] = AutomationIcon;
Components['check'] = Check;
Components['hide'] = Hide;
Components['manage_apps'] = ManageApps;
Components['menu_icon'] = MenuIcon;
Components['search_test_dev'] = SearchTestDev;
Components['license_icon'] = LicenseIcon;
Components['add_filled_icon'] = AddFilledIcon;
Components['edit_pencil_icon'] = EditPencilIcon;
Components['arrow_icon'] = ArrowIcon;
Components['zip_file_icon'] = ZipFileIcon;
Components['info_icon_with_background'] = InfoIconWithBackground;
Components['recorded_element'] = RecordedElement;
Components['add_entity'] = AddEntity;
Components['expand_icon'] = ExpandIcon;
Components['add_icon'] = AddIcon;
Components['export_icon'] = ExportIcon;
Components['video_camera'] = VideoCamIcon;
Components['remove_user'] = RemoveUser;
Components['schedule'] = Schedule;
Components['clear_result'] = ClearResult;
Components['maximize'] = Maximize;
Components['minimize'] = Minimize;
Components['manual_tagged'] = ManualTagged;
Components['manual_untagged'] = ManualUnTagged;
Components['ai_tagged'] = AiTagged;
Components['ai_untagged'] = AiUnTagged;
Components['view_more'] = ViewMore;
Components['attachment'] = Attachment;
Components['suite_icon'] = SuiteIcon;
Components['download_filled'] = DownloadFilled;
Components['edit_filled'] = EditFilled;
Components['close_circle'] = CloseCircleIcon;
Components['add_circled'] = AddCircled;
Components['padlock'] = Padlock;
Components['bold-icon'] = BoldIcon;
Components['font-color-icon'] = FontColorIcon;
Components['italic-icon'] = ItalicIcon;
Components['underline-text-icon'] = UnderlineIcon;
Components['format-painter-icon'] = FormatPainterIcon;
Components['redo-icon'] = RedoIcon;
Components['undo-icon'] = UndoIcon;
Components['paint-icon'] = PaintIcon;
Components['help'] = Help;
Components['border-all-sides'] = BorderAllSides;
Components['border-bottom'] = BorderBottom;
Components['border-left'] = BorderLeft;
Components['border-none'] = BorderNone;
Components['border-outer'] = BorderOuter;
Components['border-right'] = BorderRight;
Components['border-top'] = BorderTop;
Components['text-align-right'] = TextAlignRight;
Components['text-align-center'] = TextAlignCenter;
Components['text-align-left'] = TextAlignLeft;
Components['chatbot_header'] = ChatbotHeader;
Components['chatbot_loader'] = ChatbotLoader;
Components['chatbot_logo'] = ChatbotLogo;
Components['new_chat'] = NewChat;
Components['chatbot_hidden_logo'] = ChatbotHiddenLogo;
Components['nlp_suggestion_icon'] = NlpSuggestionIcon;
Components['expand'] = Expand;
Components['collapse'] = Collapse;
Components['open_fullscreen'] = OpenFullScreen;
Components['close_fullscreen'] = CloseFullScreen;
Components['close_icon'] = CloseIcon;
Components['dismiss_icon'] = Dismiss;
Components['live_web_icon'] = LiveWebIcon;
Components['live_mobile_icon'] = LiveMobileIcon;
Components['auto_fill_steps_icon'] = AutoFillSteps;

// images
Components['opera_icon'] = getIconByName('opera.png');
Components['Chrome'] = getIconByName('Chrome.svg');
Components['Firefox_icon'] = getIconByName('Firefox.svg');
Components['Microsoft_Edge_icon'] = getIconByName('Microsoft_Edge.svg');
Components['safari_icon'] = getIconByName('safari.png');
Components['explorer_icon'] = getIconByName('explorer.svg');
Components['edge_icon'] = getIconByName('edge.png');
Components['ie_icon'] = getIconByName('ie.png');
Components['windows_icon'] = getIconByName('windows-icon.svg');
Components['Linux_icon'] = getIconByName('LINUX-LOGO.svg');
Components['apple_icon'] = getIconByName('apple_icon.svg');
Components['apple_svg'] = getIconByName('apple-853-675472.svg');
Components['apple_png'] = getIconByName('apple.png');
Components['samsung_png'] = getIconByName('samsung.png');
Components['android_png'] = getIconByName('android.png');
Components['remove_circle_icon'] = getIconByName('remove_circle.jpg');
Components['dashboard_logo'] = getIconByName('dashboard_logo.svg');
Components['Remove_user'] = getIconByName('Remove_user.svg');
Components['toggle_menu'] = getIconByName('toggle_menu.svg');
Components['copy_init_icon'] = getIconByName('copy-init.svg');
Components['Project_Menu_icon'] = getIconByName('Project Menu.svg');
Components['Execution_gray_icon'] = getIconByName('Execution_gray.svg');
Components['Attach_icon'] = getIconByName('Attach_icon.svg');
Components['eye_logo'] = getIconByName('eye_logo.svg');
Components['analytics_icon'] = getIconByName('analytics_icon.svg');
Components['drag_icon_black_24dp'] = getIconByName(
  'drag_indicator_black_24dp.svg'
);
Components['terminateExecution_icon'] = getIconByName('terminateExecution.svg');
Components['repository_logo'] = getIconByName('repository_logo.svg');
Components['testdata_logo'] = getIconByName('testdata_logo.svg');
Components['info_icon'] = getIconByName('info_icon.svg');
Components['close_black'] = getIconByName('close_black.svg');
Components['close_blue'] = getIconByName('close_black1.svg');
Components['remove_user_icon'] = getIconByName('remove-user-icon.svg');
Components['xml'] = getIconByName('xml.svg');
Components['text'] = getIconByName('txt.svg');
Components['rar'] = getIconByName('rar.svg');
Components['ppt'] = getIconByName('ppt.svg');
Components['png'] = getIconByName('png.svg');
Components['open_defects'] = getIconByName('OpenDefectsIcon.svg');
Components['json'] = getIconByName('json.svg');
Components['jpg'] = getIconByName('jpg.svg');
Components['excel'] = getIconByName('excel.svg');
Components['csv'] = getIconByName('csv.svg');
Components['defect_template_1'] = getIconByName('Temp1.png');
Components['defect_template_2'] = getIconByName('Temp2.png');
Components['defect_template_3'] = getIconByName('Temp3.png');
Components['no_data_found'] = getIconByName('no-data-found.svg');
Components['no_execution'] = getIconByName('no-result-found.png');
Components['error_icon'] = getIconByName('error_icon.svg');
Components['switch_license'] = getIconByName('switch_license_img.svg');
Components['warning_icon'] = getIconByName('warning_icon.svg');
Components['curve_arrow'] = getIconByName('curve_arrow.png');


export default Components;
